<template>
  <div id="mySidenav" class="sidenav">
    <div class="sidenav-header">
      <strong style="margin-left: 1em;">{{ title }}</strong>
      <a style="margin-right: 1em;" href="javascript:void(0)" class="closebtn" v-on:click="closeNav()">
        <font-awesome-icon class="chevron-header" icon="chevron-left"></font-awesome-icon>
      </a>
    </div>

    <!-- Botones de pestañas (Mobile) -->
    <div class="btn-container tab-container" v-show="isMobile && mode != 4">
      <button class="btn btn-drawer btn-tab" v-on:click="mode = 0; resetAllSelectedButtons()"
        :class="{ btnTabSelected: mode == 0 }">
        <font-awesome-icon icon="arrow-left" v-if="mode != 0"></font-awesome-icon>
        <font-awesome-icon icon="toolbox" v-else></font-awesome-icon>
      </button>
      <!-- Otros botones comentados por ahora -->
    </div>

    <!-- Herramientas (Mode 0) -->
    <div v-show="mode == 0" class="tools">
      <!-- Botones de herramientas -->
      <button v-for="item in menuData" :key="item.id" class="btn-drawer" v-on:click="onClickSelectTool(item.id)">
          <NavDrawerIcon
            :name="item.id"
            :icon="item.icon"
            class="navdrawer-icon"
          />

   
        <p class="navdrawer-label">{{ item.label }}</p>
      </button>

      <button class="btn-drawer exit" v-on:click="onClickGoHome()">

        <NavDrawerIcon name="exit" class="navdrawer-icon" />

  
        <p class="navdrawer-label exit">Salir del Mapa</p>
      </button>
    </div>

  </div>
</template>

<script>

import { vuex } from '@/components/mixin/vuex.js'
import NavDrawerIcon from '@/components/mapControls/NavDrawerIcon.vue'
import { MAP_TOOLS, PROTECTED_MAP_TOOLS } from '@/components/mapControls/mapToolsCatalog.js'
export default {
  name: 'NavDrawer',
  mixins: [vuex],
  components: {
    NavDrawerIcon
  },
  data() {
    return {
      mode: 0,
      lastMode: 0
    }
  },
  computed: {
    // Catálogo filtrado por las herramientas habilitadas del mapa (QA-11).
    // null = mapa sin configurar o lista aún no cargada: se muestra todo.
    menuData: function () {
      const enabled = this.$store.state.enabledMapTools
      return enabled
        ? MAP_TOOLS.filter(tool => enabled.includes(tool.id) || PROTECTED_MAP_TOOLS.includes(tool.id))
        : MAP_TOOLS
    },
    title: function () {
      switch (this.mode) {
        case 0: return 'Herramientas'
        case 1: return 'Lista de capas'
        case 2: return 'Gráficos'
        case 3: return 'Buscador'
        case 4: return 'Simbología'
        case 5: return 'Selección'
        default: return 'Listado';
      }
    },
    isActive: function () {
      // Verifica si el control navDrawer está activo en el store
      const control = this.mapControlValues('navDrawer');
      return control ? control.active : false;
    }
  },
  methods: {
    openNavAnimation: function () {
      if (this.mode == 4) {
        this.mode = this.lastMode
      }
      const sidenav = document.getElementById("mySidenav");
      if (sidenav) {
        if (this.isMobile) {
          sidenav.style.width = "100vw";
        } else {
          sidenav.style.width = "15em";
        }
      }
    },
    closeNavAnimation: function () {
      const sidenav = document.getElementById("mySidenav");
      if (sidenav) {
        sidenav.style.width = "0";
      }
    },
    closeNav: function () {
      this.selectMapControl('navDrawer', false)
      this.closeNavAnimation();
      // Resetear al menú principal al cerrar, con un pequeño delay para que no se vea el cambio brusco
      setTimeout(() => {
        this.mode = 0;
      }, 300);
    },
    resetAllSelectedButtons: function () {
      this.$store.commit('resetMapToolsSelection')
    },
    onClickSelectTool: function (tool) {
      console.log(`[NavDrawer] Se activa herramienta: ${tool}`)

      // Siempre cerrar el nav drawer al seleccionar una herramienta
      this.closeNav()

      if (tool === 'legends') {
        // Legends is a CONTROL, not a tool
        this.selectMapControl('legends', true)
      } else {
        // Cambiar herramienta seleccionada
        this.selectMapTool(tool, true)
      }
    },
    onClickGoHome: function () {
      this.selectMapControl('navDrawer', false)
      // Lógica de navegación simple por ahora
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/inicio/');
      }
    }
  },
  watch: {
    'isActive': function (newValue) {
      if (newValue) {
        this.openNavAnimation();
      } else {
        this.closeNavAnimation();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidenav {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100000000;

  width: 0;
  height: 100%;

  background-color: var(--color-white);
  overflow-x: hidden;
  transition: width 0.5s;
  border-radius: 6px;
  a {
    color: #006fb3;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: #f7e200;
    }
  }
}
.navdrawer-icon{
  color:var(--color-steel); 
  font-size: 0.8em;
  background: transparent;
}
.sidenav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--color-white);
  height: 4em;
  background: var(--color-navy);

  .chevron-header {
    color: var(--color-mist);
    font-size: 2em;
  }
}

.tools {
  display: flex;
  flex-direction: column;
  background:var(--color-white);
}

.btn-container {
  display: flex;
  justify-content: space-evenly;

  .btn-drawer {
    justify-content: center;
    width: 5em;
    height: 2em;
  }

  .btn-drawer:hover {
    background: var(--color-mist);
  }
}

.tab-container {
  justify-content: flex-start;
  width: 100%;
  background: #f1f1f1;

  button {
    min-width: 1em;
  }
}

.btn-drawer {
  display: flex;
  align-items: center;
  width: 100%;
  height: 4em;

  padding: 0.3em 0.9em;

  color: var(--color-graphite);
  background: transparent;

  border: none;
  border-bottom: 1px solid var(--color-line);
  border-radius: 0;

  font-size: 0.9em;
  font-weight: 500;
  text-align: left;
  cursor: pointer;

  p {
    margin: 0 0 0 0.5em;
  }

  &:hover {
    color: var(--color-graphite);
    background: var(--color-mist);
    box-shadow: inset 3px 0 0 var(--color-orange);
  }

  &.exit {
    color: var(--color-red);
  }

  // &:focus,
  // &:active {
  //   outline: none;
  //   box-shadow: none;
  // }
}

.navdrawer-label{
  color: var(--color-graphite);
  font-weight: 500;
}
.btn-tab {
  width: min-content;
  border-bottom: 2px solid gray;
}

.btnTabSelected {
  color: var(--color-white);
  background: var(--color-navy);
  box-shadow: -2px -2px 0.25em var(--color-line);
}

.fa-lg {
  font-size: 2em;
}
</style>
